import { useQueryState } from 'nuqs'

function useShelfDetails() {
  const [shelfId, setShelfId] = useQueryState('shelf')

  return {
    shelfId: shelfId ?? undefined,
    setShelfId: (id?: string) => setShelfId(id ?? null),
  }
}

export default useShelfDetails

